import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'

import { AuthProvider } from '@/app/providers/Auth.provider.tsx'
import { ThemeProvider, useTheme } from '@/app/providers/ThemeProvider.tsx'
import { AppRouter } from '@/app/routes/AppRouter.tsx'

import { getAccessToken } from '@/shared/api/authToken.service.ts'

const queryClient = new QueryClient()

const InnerApp = () => {
	const { theme } = useTheme()
	return (
		<AuthProvider initialAuth={!!getAccessToken()}>
			<Toaster theme={theme} position='top-right' />
			<AppRouter />
		</AuthProvider>
	)
}

const AppProvider = () => (
	<QueryClientProvider client={queryClient}>
		<ThemeProvider defaultTheme='system' storageKey='vite-ui-theme' accentStorageKey='vite-ui-accent'>
			<InnerApp />
		</ThemeProvider>
	</QueryClientProvider>
)

export default AppProvider
